// Pretend the 3js canvas is larger than it is, so we don't have issues with the
// mobile bar going on and off the scroll when scrolling up/down 😎
export const MOBILE_BAR_INCREASE = 150;
